import Api from './api';

const DividaService = {

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/divida/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/divida/buscar?${params}`)
        return response
    }
}

export default DividaService;